import { atom, useAtom } from 'jotai'
import _ from 'lodash'

const stepErrorAtom = atom(null)

const useStepError = () => {
  const [stepError, setStepError] = useAtom(stepErrorAtom)
  const setStepWithLog = (error) => {
    setStepError(error)
    if (_.get(global, 'window.ISO_REDUX_DATA.page.isProd', false)) {
      return
    }

    console.log('setStepWithLog', error)
  }

  return [stepError, setStepWithLog]
}

export default useStepError
